module.exports = __webpack_public_path__ + "static/media/acaisoft-avatar-new.fcf7031f.jpg";